import { MyTableComponent, Button } from "components"
import { useEffect, useState, useRef } from "react"
import { Box } from "theme-ui"
import openIcon from "./selecticon.png"
import { useTranslation } from "react-i18next"
import { useSettingsTimeDomainQuery } from "../../store/Features/settings/settingsTimeDomain-api-slice"

export const TimeDomain = () => {
 const { data } = useSettingsTimeDomainQuery()

 // language translator
 const { t } = useTranslation("translation")
 const containerRef = useRef<HTMLDivElement>(null)
 const [isAtStart, setIsAtStart] = useState(true)
 const [isAtEnd, setIsAtEnd] = useState(false)

 const columns = [
  { Header: t("day"), accessor: "info1" },
  { Header: t("date"), accessor: "info2" },
  { Header: t("headquarters"), accessor: "info3" },
  { Header: t("federalState"), accessor: "info4" },
  {
   Header: "Action",
   Cell: () => (
    <div className="flex">
     <div className="mr-2">
      <Button color={"darkBrown"} size={"tableSmallSize"}>
       {t("edit")}
      </Button>
     </div>

     <div>
      <Button color={"pink"} size={"tableSmallSize"}>
       {t("delete")}
      </Button>
     </div>
    </div>
   ),
  },
 ]

 useEffect(() => {
  if (containerRef.current) {
   containerRef.current.addEventListener("scroll", handleScroll)
   return () => {
    // eslint-disable-next-line
    containerRef.current?.removeEventListener("scroll", handleScroll)
   }
  }
  // eslint-disable-next-line
 }, [])
 //   horizontal scroll method for changing the color of active button
 const handleScroll = () => {
  if (containerRef.current) {
   setIsAtStart(containerRef.current.scrollLeft === 0)
   setIsAtEnd(
    containerRef.current.scrollLeft + containerRef.current.clientWidth ===
     containerRef.current.scrollWidth,
   )
  }
 }
 //   scrollLeft method
 const scrollLeft = () => {
  if (containerRef.current) {
   containerRef.current.scrollLeft -= 100
  }
 }
 //   scrollRight method
 const scrollRight = () => {
  if (containerRef.current) {
   containerRef.current.scrollLeft += 100
  }
 }

 return (
  <div className="w-full lg:w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full pt-5">
   <div className="flex lg:flex-row flex-col lg:justify-between lg:items-center w-[98%] mx-auto pb-4">
    <div>
     <h1 className="font-semibold text-2xl">{t("timeRanges")}</h1>
     <p className="text-sm">Wählen Sie das Jahr aus dem Sie die Zeitbereiche anzeigen möchten:</p>
    </div>

    <div className="flex lg:justify-between lg:w-[14%] justify-end w-full ">
     <div className="bg-white rounded-lg pr-5 pl-2 text-black">2023</div>
     <div className="flex lg:w-[40%] lg:justify-between">
      <button
       onClick={scrollLeft}
       className={`h-6 w-6 rounded-lg flex items-center justify-center ${
        isAtStart ? "opacity-40 bg-white" : "bg-white"
       } `}
      >
       <img className="rotate-[-90deg]" src={openIcon} alt="prev" />
      </button>
      <button
       onClick={scrollRight}
       className={`h-6 w-6 rounded-lg flex items-center justify-center ${
        isAtEnd ? "opacity-40 bg-white" : "bg-white"
       }`}
      >
       <img className="rotate-90" src={openIcon} alt="next" />
      </button>
     </div>
    </div>
   </div>
   <div className="flex w-full overflow-x-auto hide-scroll-icon" ref={containerRef}>
    <div className="min-w-[70%] ">
     <Box bg="highlight" color="text-black">
      <div className="flex justify-between items-center py-3 px-3">
       <h1 className="Jakarta-font font-semibold lg:text-lg text-sm">{t("publicHolidays")} 2023</h1>
       <div>
        <Button size={"xl"}>{t("showTimeRanges")}</Button>
       </div>
      </div>
     </Box>

     {/* ====== TableComponent ====== */}
     <MyTableComponent
      fullHeight={true}
      columns={columns}
      data={data ? data : []}
      paginate={false}
     />
    </div>
    <div className="min-w-[70%] ml-3 ">
     <Box bg="highlight" color="text-black">
      <div className="flex justify-between items-center py-3 px-3">
       <h1 className="Jakarta-font font-semibold lg:text-lg text-sm">{t("publicHolidays")} 2023</h1>
       <div>
        <Button size={"xl"}>{t("showTimeRanges")}</Button>
       </div>
      </div>
     </Box>

     {/* ====== TableComponent ====== */}
     <MyTableComponent
      fullHeight={true}
      columns={columns}
      data={data ? data : []}
      paginate={false}
     />
    </div>
   </div>
  </div>
 )
}
